import GenericView from 'js/views/generic.view';
import Template from 'js/templates/subscriber.report.listgroup.row.hbs';
import {template} from "../adapters/backbone-decorators";

@template(Template)
class SubscriberReportListgroupRow extends GenericView {
    constructor(options) {
        super(options);
        this.CCview = options.CCview;
        this.postpaid = options.postpaid;
        this.model.set("postpaid", this.postpaid);
    }

    render() {
        super.render();
    }
}

export default SubscriberReportListgroupRow;
